import { LOADING_SHIPPING_AREAS, SET_SHIPPING_AREAS } from "../types/shipping";

const initialState = {
  loading: false,
  shippingAreas: [],
};

const shippingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SHIPPING_AREAS:
      return {
        ...state,
        loading: true,
      };
    case SET_SHIPPING_AREAS:
      return {
        ...state,
        loading: false,
        shippingAreas: action.payload,
      };
    default:
      return state;
  }
};

export default shippingReducer;
